import type { SessionService } from '@efdigital/ll-addon-auth';
import type { CoachProfile } from '@efdigital/ll-addon-data';
import type { CoachingCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import { queryCoachProfileByUserId } from '../../../../data/builders/coaching/coach-profiles.ts';

export interface CoachingCoachSettingsIndexModel {
  published: CoachProfile;
  /** The coach's in-flight change request, if one is awaiting review. */
  pending: CoachProfile | null;
}

export default class CoachingCoachSettingsIndexRoute extends Route<CoachingCoachSettingsIndexModel> {
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoachSettingsIndexModel> {
    const { coach: published } = this.modelFor(
      'coaching.coach'
    ) as CoachingCoachModel;

    const response = await this.store.request(
      queryCoachProfileByUserId(this.session.cached.userId!, 'pending_review')
    );

    return {
      published,
      pending: response.content.data[0] ?? null,
    };
  }
}
